require('./lib/polyfill')
const hotjar = require('./lib/hotjar')
const googleAnalytics = require('./lib/googleAnalytics')
const omniture = require('./lib/omniture')
const gtm = require('./lib/gtm')
const logRocket = require('./lib/logRocket')
const commonHelpers = require('./modules/common/helpers')
const constants = require('./modules/common/constants')

/* Helpers */

function _getCombinedConfig(config, lob) {
  const analyticsConfig = config.analytics[lob]
  const omnitureConfig = config.OMNITURE_GLOBAL_OBJ
  analyticsConfig.mc_id = omnitureConfig ? omnitureConfig.mc_id : ''
  analyticsConfig.s = Object.assign(
    {},
    analyticsConfig.s || {},
    omnitureConfig ? omnitureConfig.s : {}
  )
  return analyticsConfig
}

/**
 Intermittently, window.Visitor is not loaded yet.
 This promise executor tries to wait for it.
 */
function _omniturePreLoaded(resolve, reject, count) {
  if (count === 0) {
    return reject({
      Visitor: window && window.Visitor,
    })
  }
  if (count === undefined) count = 5 // max tries
  if (window && window.Visitor) {
    resolve()
  } else {
    setTimeout(_omniturePreLoaded.bind(null, resolve, reject, count - 1), 250)
  }
}

/* Remember current analytics enabled settings */
let analyticsEnabled = constants.enabled

/* Exported Functions */

/**
 * Utility function to initialize the various analytics libraries
 * This is very old and in modern times we just load GTM and then
 * we load everything from there but we are keeping this for
 * backwards compatibility.
 * As of 2021-01-21 GTM is loaded via node-foundation by all apps
 *
 * @param {object} config usually retrieved from ssp-configuration repo
 * @param {string} lob use cre
 * @param {object} enabled refer to src/modules/common/constants.js to send the config
 */
function init(config, lob, enabled) {
  if (!config || !lob) {
    return Promise.resolve({ msg: 'config or lob missing' })
  }

  analyticsEnabled = Object.assign({}, constants.analyticsEnabled, enabled)

  if (!constants.validLobList.includes(lob)) {
    return Promise.resolve({
      msg:
        'Invalid line of business passed. Please pass one of ' + constants.validLobList.join(', '),
    })
  }

  if (config.analytics) {
    const analyticsConfig = config.analytics[lob]
    // HotJar
    analyticsEnabled.hotjar && hotjar.setUpHotjarScripts(analyticsConfig.hotjar_id)
    // GTM
    // analyticsEnabled.gtm &&
    //   gtm.setUpGoogleTagManagerScripts(
    //     analyticsConfig.gtm.gtm_id_mkt
    //   )
    // GA
    analyticsEnabled.ga && googleAnalytics.setUpGoogleAnalyticsScripts(analyticsConfig.ga_id)
    // Omniture
    if (config.OMNITURE_GLOBAL_OBJ && analyticsEnabled.omniture) {
      const combinedConfig = _getCombinedConfig(config, lob)
      return new Promise(_omniturePreLoaded)
        .then(function () {
          return omniture.setOmnitureGlobalVariable(combinedConfig)
        })
        .catch((e) => console.error(e))
    }

    return Promise.resolve({})
  }

  return Promise.resolve({ msg: 'Invalid analytics config passed' })
}

// Page Load Tracking
function firePageTrackingWithContext(
  lob,
  user,
  trackObj,
  gaPath = window.location.pathname,
  shouldFireGATracking = true
) {
  if (!lob || !constants.validLobList.includes(lob)) {
    console.error(
      '>>> Invalid line of business passed for page tracking. Please pass one of ',
      constants.validLobList
    )
    return
  }
  const cre = require('./modules/cre')

  // For resi, ga is still loaded, but tracking is disabled; so need to keep the `shouldFireGATracking` flag.
  analyticsEnabled.ga && shouldFireGATracking && googleAnalytics.firePageTracking(gaPath)

  if (analyticsEnabled.omniture) {
    switch (lob) {
      case 'cre':
        cre.firePageTrackingWithContext(user, trackObj)
        break
    }
  }
}

// Custom Event Tracking
function trackWithContext(context, productName) {
  if (analyticsEnabled.omniture) {
    const appendedContext = Object.assign({}, commonHelpers.getCommonContextData(), context)
    omniture.trackCustomEventWithContext(appendedContext, productName)
  }
}

module.exports = {
  init,
  firePageTrackingWithContext,
  trackWithContext,
  gtm,
  logRocket,
}
